import Layout from "src/components/sections/transfers/prepak"
import { getInventoryData } from "src/components/sections/payment/index.data"

export const labels = ["Fit", "New", "Processed", "Unprocessed", "Total"]

function ProcessingOut(): JSX.Element {
    return <Layout dataInventory={getInventoryData(labels)} from="out-for-processing" />
}
export default ProcessingOut
